module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule-module"
  }, [(_vm.config.logoStatus) ? _c('span', {
    staticClass: "logo"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rule-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.show($event)
      }
    }
  }, [_vm._v("规则")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slider-l"
    }
  }, [(_vm.status) ? _c('div', {
    staticClass: "rule-wrap"
  }, [_c('i', {
    staticClass: "close-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hide($event)
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "tit"
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('ol', {
    staticClass: "rule-list"
  }, _vm._l((_vm.config.rules), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }))]) : _vm._e()])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-159b9f38", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-159b9f38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/act/march_promotion/components/rule.vue
// module id = 272
// module chunks = 0